export default __webpack_public_path__ + "static/media/ring2.2e7c8786.png";